<template>
    <div class="users-style">

      <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance Settings<span>
          <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance Settings / Long Service Leave</span>
      </h4>

        <div class="ibox px-3 py-4 mt-4">   
            <div class="mb-3">
                <div class="row">
                    <div class="col-6">
                        <div class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0 pt-0 pb-0 roster-ibox">
                            <h4 class="clearfix mb-0">
                                <span class="float-left">Long Service Leave
                                    <span class="title-sub-text"></span>
                                </span>
                                <span class="float-right"></span>
                            </h4>
                        </div>
                    </div>

                    <div class="col-6 d-flex justify-content-end align-items-center">
                        <b-button v-if="ce" id="show-btn" class="" @click="addNew">+ Add Slot</b-button>
                    </div>
                </div>

            </div>

            <!-- Table -->
            <div class="row justify-content-center no-margin">
                <div class="col-sm-12 px-0">
                    <b-overlay :show="showoverlay_list" rounded="sm">
                        <table class="table dataTable border">
                            <thead>
                                <tr class="table-head">
                                    <td>Minimum Months</td>
                                    <td>Days Entitled</td>
                                    <td class="text-right" v-if="ce">Action</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(policy, index) in policies" :key="index">
                                    <td>{{ policy.minimum_required_months }}</td>
                                    <td>{{ policy.days_entitled }}</td>
                                    <td class="position-relative text-right" v-if="ce">
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                            href="#" role="button" data-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false"><b-icon
                                                icon="three-dots-vertical"></b-icon></a>
                                        <div class="dropdown-menu action-dropdown-menu"
                                            aria-labelledby="actionDropdown">
                                            <b-button-group class="mr-0">
                                                <b-button variant="outline-secondary"
                                                    @click="editPolicy(policy.id, policy.minimum_required_months, policy.days_entitled)">
                                                    <b-icon icon="pencil"></b-icon>Edit
                                                </b-button>
                                            </b-button-group>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                        <div v-else class="px-3">
                            <ul class="pagination b-pagination float-left mb-0 mt-1">
                                <li class="page-item disabled m-2">View</li>
                                <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                <li class="page-item disabled m-2">per page. Total {{policies.length}} records found.</li>
                            </ul>
                            <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>

                        </div>
                    </b-overlay>
                </div>
            </div>
        </div>

        <b-modal id="bv-modal-add-longservice-leave" size="xm" scrollable hide-footer :title=" (this.fdata.id == '' ? 'Add' : 'Edit' )+ ' Long Service Leave'">
            <b-form @submit.stop.prevent="savePolicy">
                <b-alert :show="this.fdata.id == ''"><span class="text-danger"><strong>Attention:</strong> Long service leave cannot be deleted. If updates are needed, please make the necessary adjustments.</span></b-alert>
                <b-form-group label="Minimum Required Months" class="required-field" label-for="minimum-required-months"  >
                    <b-form-input id="minimum-required-months" v-model="fdata.minimum_required_months" v-validate="{required: true, numeric: true,min_value:1, max_value:1200}" name="minimum_required_months" :state="validateState('minimum_required_months')" aria-describedby="minimum-required-months-feedback" data-vv-as="Month" ></b-form-input>
                    <b-form-invalid-feedback id="minimum-required-months-feedback"> {{ veeErrors.first('minimum_required_months') }} </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Days Entitled" class="required-field" label-for="days-entitled" >
                    <b-form-input id="days-entitled" v-model="fdata.days_entitled" v-validate="{required:true,numeric:true,min_value:1,max_value:1200}" name="days_entitled" :state="validateState('days_entitled')" aria-describedby="days-entitled-feedback" data-vv-as="Entitled Days"></b-form-input>
                    <b-form-invalid-feedback id="days-entitled-feedback">{{ veeErrors.first('days_entitled') }}</b-form-invalid-feedback>
                </b-form-group>
                
                <div class="full width text-center">
                    <b-button type="submit" variant="primary" v-if="fdata.id">Update</b-button>
                    <b-button type="submit" variant="primary" v-else>Save</b-button>
                    <b-button class="ml-2 custom-wizard-btn" @click="$bvModal.hide('bv-modal-add-longservice-leave')" variant="primary">Cancel</b-button>
                    <b-button class="ml-2 custom-wizard-btn" @click="resetForm()">Reset</b-button>
                </div>
            </b-form>
        </b-modal>

    </div>
</template>

<script>
export default {
    data() {
        return {
            policies: [],
            showoverlay_list: false,
            ce: true,
            search:'',
            fdata: {
                id: '',
                minimum_required_months: '',
                days_entitled: '',
            },
            pagination: {currentPage: 1, pages:1},
            length: 20,
            temp_length:20,
            length_options:
                [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],
        };
    },
    created: function () {
        this.getPolicies();
    },
    methods: {
        resetForm()
        {
            this.fdata.minimum_required_months = '';
            this.fdata.days_entitled = '';                       
        },
        getPolicies() {
            this.showoverlay_list = true;
            axios.get(this.$api_url + '/leave-attendance/longservice-leave/get-company-policies')
                .then((response) => {
                    this.policies = response.data;
                    this.showoverlay_list = false;
                })
                .catch((err) => {
                    console.error('Error fetching policies:', err);
                    this.policies = [];
                    this.showoverlay_list = false;
                });
        },
        addNew() {
            this.fdata = {
                id: '',
                minimum_required_months: '',
                days_entitled: '',
            },
            this.$bvModal.show('bv-modal-add-longservice-leave');
        },
        savePolicy(e) {

            if(this.fdata.id != ''){
                this.updatePolicy(e);
                return;
            }

            this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    e.preventDefault();


            this.showoverlay = true;

            axios.post(this.$api_url + '/leave-attendance/longservice-leave/save-policy', this.fdata)
                .then(response => {
                    this.$bvToast.toast(response.data.message || 'Saved successfully.', {
                        title: 'Success',
                        variant: 'success',
                        solid: true
                    });

                    this.$bvModal.hide('bv-modal-add-longservice-leave');
                    this.getPolicies();
                })
                .catch(error => {
                    const message =
                        error.response && error.response.data && error.response.data.message
                            ? error.response.data.message
                            : 'An unexpected error occurred.';

                    this.$bvToast.toast(message, {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                })
                .finally(() => {
                    this.showoverlay = false;
                });
                });

        },

            validateState:function(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
        editPolicy(id, minimum_required_months, days_entitled) {
            console.log('Edit leave');
            this.fdata.id = id;
            this.fdata.minimum_required_months = minimum_required_months;
            this.fdata.days_entitled = days_entitled;
            this.$bvModal.show('bv-modal-add-longservice-leave');
        },
        updatePolicy(e) {

            this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    e.preventDefault();
            this.showoverlay = true;

            axios.post(this.$api_url + '/leave-attendance/longservice-leave/update-policy', this.fdata)
                .then(response => {
                    this.$bvToast.toast(response.data.message || 'Saved successfully.', {
                        title: 'Success',
                        variant: 'success',
                        solid: true
                    });

                    this.$bvModal.hide('bv-modal-add-longservice-leave');
                    this.getPolicies();
                })
                .catch(error => {
                    const message =
                        error.response && error.response.data && error.response.data.message
                            ? error.response.data.message
                            : 'An unexpected error occurred.';

                    this.$bvToast.toast(message, {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                })
                .finally(() => {
                    this.showoverlay = false;
                });
            });
        },
    },
    computed:
    {
        filteredData()
        {
            let filtered_list = this.policies;
            return filtered_list;
        },
        paginatedData()
        {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        }
    }
};
</script>

